import { IconButton, InputAdornment, styled } from '@mui/material'
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded'
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded'
import { intl } from '../../../../i18n'
import { colorPalette } from '../../../style/colorPalette'

type Props = {
  visible: boolean
  onToggle: () => void
}

export const PasswordVisibilityAdornment = ({ visible, onToggle }: Props) => (
  <InputAdornment position="end">
    <VisibilityIconButton
      onClick={onToggle}
      edge="end"
      aria-label={intl.formatMessage({
        id: visible ? 'login.hidePassword' : 'login.displayPassword',
      })}
    >
      {visible ? <VisibilityOffRoundedIcon /> : <VisibilityRoundedIcon />}
    </VisibilityIconButton>
  </InputAdornment>
)

const VisibilityIconButton = styled(IconButton)({
  color: colorPalette.monotone[4],
  '&:hover': {
    color: colorPalette.skyBlue[7],
  },
})
